import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {PreregistrationService} from "../../../shared/services/preregistration/preregistration.service";
import {Preregistration} from "../../../shared/models/preregistration";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: "app-preregistration-delete-confirmation-modal",
    templateUrl: "./preregistration-delete-confirmation-modal.component.html",
    styleUrls: ["./preregistration-delete-confirmation-modal.component.scss"]
})
export class PreregistrationDeleteConfirmationModalComponent {

    @Input()
    preregistration!: Preregistration;
    submitting: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private preregistrationService: PreregistrationService,
        private toastr: ToastrService
    ) {}

    submit() {
        this.submitting = true;

        this.preregistrationService.delete(this.preregistration.id).pipe(take(1)).
            subscribe(
                () => {
                    this.submitting = false;
                    this.toastr.success("Pré-inscription supprimée");
                    this.activeModal.close(this.preregistration);
                },
                () => {
                    this.submitting = false;
                    this.toastr.error(
                        "Erreur lors de la suppression de la pré-inscription",
                        "Erreur"
                    );
                }
            );
    }
}
